import { groupRows } from '@texas/utils/helpers/groupingHelpers';

interface MatrixRow {
  matrixNodeXValue: string;
  controlledById: number | null;
  compositionGroupId: number;
  supplierId: number | null;
  branchIdentifier: string;
  version: number;
  currencyId?: number;
  defaultCurrencyId: number;
}

export function groupMatrixRows<T extends MatrixRow>(rows: T[]) {
  return groupRows(rows, (row, index) =>
    row.matrixNodeXValue
      ? JSON.stringify([
          row.controlledById ?? row.compositionGroupId,
          row.supplierId,
          row.branchIdentifier,
          row.version,
          row.currencyId ?? row.defaultCurrencyId,
          row.matrixNodeXValue,
        ])
      : `empty-${index}`,
  );
}
